<template>
    <div>
        <div class="d-inline">
            <BIcon icon="calendar3" class="i-purple-color"></BIcon>
        </div>
        <VueCtkDateTimePicker
            v-model="date"
            button-color="#6299EB"
            color="#6299EB"
            format="YYYY-MM-DD"
            formatted="l"
            label=""
            :locale="$i18n.locale"
            :range="false"
            input-size="sm"
            :no-header="true"
            :no-shortcuts="true"
            output-format="YYYY-MM-DD"
            :only-date="true"
            :right="false"
            id="date-time-picker-for-camera"
            class="datetime-pk d-inline"
            :no-button-now="true"
            @is-hidden="$emit('validate', date)"
        >
            <b-button variant="link" class="datetime-pk-trigger"></b-button>
        </VueCtkDateTimePicker>
    </div>
</template>

<script>
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

    export default {
        name: "ModalDatePicker",
        components: {
            VueCtkDateTimePicker
        },
        props: {
            selectedDate: String
        },
        data() {
            return {
                date: this.selectedDate
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/variables';

    .i-purple-color {
        color: $purpleColor;
    }
</style>